import React, { useState, useEffect } from "react";
import { FmPageTitle, FmBack, FmCustomizeBox, FmRecommendedProduct, FmUnderlineNav, FmBlackPopup, FmButton } from "../../../Components";

import { useIsMobile } from "../../../Hooks";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { LOGGED_IN_ROUTES, SMALL_MESURMENT_UNIT } from "../../../Constants";
import { useDispatch, useSelector } from "react-redux";
import { AgriSolutionState, GeneralState } from "../../../Redux";
import { FmAllModals } from "../../../Components/Modals";
import useStyles from "./ResultsStagePage.styles";
import { ZERO, ONE } from "../../../Utils/Consts";
import { shareableItemTypes } from "../../../Utils/Enums";
import { Api } from "../../../Services";
import axios from "axios";
import Config from "../../../Configs";

const ResultsStagePage = () => {
  const [fertilizationModal, setFertilizationModal] = useState<boolean>(false);
  const [showSaveItemModal, setShowSaveItemModal] = useState<boolean>(false);
  const [ShowBlackSnackbar, setShowBlackSnackbar] = useState<boolean>(false);
  const [hasSaveButton, setHasSaveButton] = useState<boolean>(true);

  const classes = useStyles();
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { activeMetricMethod } = useSelector(GeneralState.Selectors.selectMetricMethods);

  const recommendedSolutionName = useSelector(AgriSolutionState.Selectors.selectRecommendedSolutionName);

  const savedItemId = useSelector(AgriSolutionState.Selectors.selectItemId);

  const valueSelected = Number(activeMetricMethod) == ONE ? ZERO : ONE;

  const onLinkClickHandler = () => {
    history.push(LOGGED_IN_ROUTES.AGRI_SOLUTION_RELEASE_CHART);
  };
  const navigateToShelfSolutionGraphRelease = () => {
    dispatch(AgriSolutionState.Actions.setReleaseGraphType(shareableItemTypes.agri_multicote_ready_made));
    onLinkClickHandler();
  };
  const navigateToCustomizeGraphRelease = () => {
    dispatch(AgriSolutionState.Actions.setReleaseGraphType(shareableItemTypes.agri_multicote_customize));
    onLinkClickHandler();
  };
  const customizedSolution = useSelector(AgriSolutionState.Selectors.selectCustomizedState);
  const releaseGraphState = useSelector(AgriSolutionState.Selectors.selectReleaseGraphState);

  const handleBack = () => {
    history.push(LOGGED_IN_ROUTES.AGRI_SOLUTION_SECOND_STEP);
  };

  const isUserSave = useSelector(AgriSolutionState.Selectors.selectIsUserSave);

  useEffect(() => {
    (window as any).dataLayer.push({
      event: "ResultsStage",
      pageUrl: "https://multimatch.haifa-group.com/multi-match/agri-solution/results",
      pageTitle: "ResultsStage",
    });
  }, []);

  const saveSolutionHandler = async () => {
    setHasSaveButton(false);
    await dispatch(AgriSolutionState.Actions.setIsUserSave(true));
    await dispatch(AgriSolutionState.Thunks.saveProcess());

    if (isUserSave) {
      setShowBlackSnackbar(true);
    }
  };

  const closeSnackbarHandler = () => {
    setShowBlackSnackbar(false);
  };

  //------------ Modals ---------------------//
  const adjustFormulaHandler = () => {
    setFertilizationModal(true);
  };
  const closeModalHandler = () => {
    setFertilizationModal(false);
  };
  const closeSaveItemModalHandle = () => {
    setShowSaveItemModal(false);
  };
  const openSaveItemModalHandle = () => {
    setShowSaveItemModal(true);
  };
  //-----------------------------------------//

  return (
    <>
      {ShowBlackSnackbar && (
        <div className={classes.snackbar_container}>
          <FmBlackPopup text={t("saveItemPopup.snackbar")} snackbar={true} onClose={closeSnackbarHandler} />
        </div>
      )}
      <div className={classes.container}>
        <div className={isMobile ? classes.title_container_mobile : classes.title_container}>
          <FmPageTitle title={t("pageStep3.subTitle")} />
          <FmUnderlineNav
            title={t("saveItemPopup.save")}
            onClick={
              !isUserSave
                ? openSaveItemModalHandle
                : isUserSave
                  ? saveSolutionHandler
                  : () => {
                      //
                    }
            }
            disabled={!hasSaveButton}
          />
        </div>
        <FmCustomizeBox
          productName={customizedSolution?.bestSolutionFormula as string}
          percentages={customizedSolution?.bestSuitFormulaCoatings as string}
          onLinkClick={navigateToCustomizeGraphRelease}
          onButtonClick={adjustFormulaHandler}
        />

        <div className={classes.recommended_container}>
          <div className={classes.bottomTitle}>{t("pageStep3.bottomTitle")}</div>
          {recommendedSolutionName ? (
            <div className={classes.bottomSubText}>{t("pageStep3.bottomDescriptionWithMatch")}</div>
          ) : (
            <div className={classes.bottomSubText}>{t("pageStep3.bottomDescriptionWithoutMatch")}</div>
          )}
          {recommendedSolutionName && (
            <div className={classes.recommendedProduct}>
              <FmRecommendedProduct
                img="./assets/HaveMatchBag.png"
                title={recommendedSolutionName}
                volume={`${
                  releaseGraphState && releaseGraphState.applicationVolume.length > ZERO
                    ? releaseGraphState.applicationVolume[valueSelected].value
                    : 0
                } ${valueSelected === 0 ? (SMALL_MESURMENT_UNIT as any)[activeMetricMethod] : (SMALL_MESURMENT_UNIT as any)[activeMetricMethod]}`}
                method={t("pageStep3.inSoil")}
                onLinkClick={navigateToShelfSolutionGraphRelease}
              />
            </div>
          )}
        </div>

        <div className={isMobile ? classes.mobile_buttons_container : classes.buttons_container}>
          <div>
            <FmBack onClick={handleBack} />
          </div>
        </div>
        <FmAllModals
          FertilizationModalIsOpen={fertilizationModal}
          FertilizationModalOnClose={closeModalHandler}
          saveItemModalIsOpen={showSaveItemModal}
          saveItemModalOnClose={closeSaveItemModalHandle}
          saveItemModalAction={saveSolutionHandler}
        />
      </div>
    </>
  );
};

export default ResultsStagePage;
